import { Outlet } from "react-router-dom";
import { Portal } from "cerulean";

import Sidebar from "../../src/modules/sidebar/components/Sidebar";
import { MainLayoutProps } from "./types";

const MainLayout = (props: MainLayoutProps) => (
  <>
    <Portal rootId="top-menu-react">
      <Sidebar {...props} />
    </Portal>
    <Outlet />
  </>
);

export default MainLayout;
